import { render } from "./UsersAdminView.vue?vue&type=template&id=0ceba471&scoped=true"
import script from "./UsersAdminView.vue?vue&type=script&lang=js"
export * from "./UsersAdminView.vue?vue&type=script&lang=js"

import "./UsersAdminView.vue?vue&type=style&index=0&id=0ceba471&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ceba471"]])

export default __exports__